exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-dash-routes-component {\n  width: 100%;\n  height: 100%;\n}\n.card-dash-routes-component h2 {\n  font-size: 12px;\n  color: #0B486B;\n  text-align: center;\n  height: 30px;\n  line-height: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.card-dash-routes-component .draft {\n  width: 100%;\n  height: 90px;\n  background-color: #f2f3f4;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.card-dash-routes-component .draft h1 {\n  font-size: 28px;\n  font-weight: bold;\n  color: #363636;\n  text-align: center;\n}", ""]);

// exports
